import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 200,
    height: '40px',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  }
}))
